import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PreloaderComponent} from './components/common/preloader/preloader.component';
import {FooterComponent} from './components/common/footer/footer.component';
import {NavbarComponent} from './components/common/navbar/navbar.component';
import {SubscribeComponent} from './components/common/subscribe/subscribe.component';
import {HomeOneComponent} from './components/pages/home-one/home-one.component';
import {HomeTwoComponent} from './components/pages/home-two/home-two.component';
import {HomeThreeComponent} from './components/pages/home-three/home-three.component';
import {ContactComponent} from './components/common/contact/contact.component';
import {BlogComponent} from './components/common/blog/blog.component';
import {ItServicesComponent} from './components/common/it-services/it-services.component';
import {ProjectManagementComponent} from './components/common/project-management/project-management.component';
import {PricingComponent} from './components/common/pricing/pricing.component';
import {OverviewComponent} from './components/common/overview/overview.component';
import {TestimonialsComponent} from './components/common/testimonials/testimonials.component';
import {RpaComponent} from './components/common/rpa/rpa.component';
import {ItConsultingComponent} from './components/common/it-consulting/it-consulting.component';
import {AboutComponent} from './components/common/about/about.component';
import {FunfactsComponent} from './components/common/funfacts/funfacts.component';
import {HowItWorksComponent} from './components/common/how-it-works/how-it-works.component';
import {BlogDetailsComponent} from './components/pages/blog-details/blog-details.component';
import {BlogPageComponent} from './components/pages/blog-page/blog-page.component';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {StickyNavModule} from "ng2-sticky-nav";
import {InitiativesComponent} from './components/common/initiatives/initiatives.component';
import {NotFoundComponent} from "./components/pages/not-found/not-found.component";
import {SolutionsComponent} from "./components/common/solutions/solutions.component";
import { Solution1Component } from './components/common/solution1/solution1.component';
import { Solution2Component } from './components/common/solution2/solution2.component';
import { LegalComponent } from './components/common/legal/legal.component';
import { CookieConsentComponent } from './components/common/cookie-consent/cookie-consent.component';

@NgModule({
    declarations: [
        AppComponent,
        PreloaderComponent,
        FooterComponent,
        NavbarComponent,
        SubscribeComponent,
        HomeOneComponent,
        HomeTwoComponent,
        HomeThreeComponent,
        ContactComponent,
        BlogComponent,
        InitiativesComponent,
        ItServicesComponent,
        ProjectManagementComponent,
        PricingComponent,
        OverviewComponent,
        TestimonialsComponent,
        RpaComponent,
        ItConsultingComponent,
        AboutComponent,
        FunfactsComponent,
        HowItWorksComponent,
        BlogDetailsComponent,
        BlogPageComponent,
        NotFoundComponent,
        SolutionsComponent,
        Solution1Component,
        Solution2Component,
        LegalComponent,
        CookieConsentComponent
    ],
    imports: [
        BrowserModule.withServerTransition({appId: 'serverApp'}),
        FormsModule,
        HttpClientModule,
        AppRoutingModule,
        StickyNavModule
    ],
    providers: [
        {provide: LocationStrategy, useClass: PathLocationStrategy},
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
